export const PASSWORD_RULES = [
  {
    pattern: /.{8,}/,
    message: 'Password must be at least 8 characters',
    hint: 'Use at least 8 characters.',
  },
  {
    pattern: /[a-z]/,
    message: 'Password must contain at least one lowercase letter',
    hint: 'Add a lowercase letter.',
  },
  {
    pattern: /[A-Z]/,
    message: 'Password must contain at least one uppercase letter',
    hint: 'Add an uppercase letter.',
  },
  {
    pattern: /[0-9]/,
    message: 'Password must contain at least one number',
    hint: 'Add at least one number.',
  },
  {
    pattern: /[!@#$%^&*]/,
    message: 'Password must contain at least one special character (!@#$%^&*)',
    hint: 'Add at least one symbol (!@#$%^&*).',
  },
  {
    pattern: /^(?!.*(.)\1\1)/,
    message: 'Password must not contain 3 or more identical consecutive characters',
    hint: 'Avoid repeating a character 3+ times in a row.',
  },
] as const;

// gloss
export const PASSWORD_POLICY_HINT = 'Use 8+ characters with a mix of uppercase, lowercase, numbers, and symbols.';

// gloss
export const validatePassword = (password: string): string[] =>
  PASSWORD_RULES.filter((rule) => !rule.pattern.test(password)).map((rule) => rule.message);

// gloss
export const firstPasswordHint = (password: string): string | null =>
  PASSWORD_RULES.find((rule) => !rule.pattern.test(password))?.hint ?? null;
